import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table-error-state font-bold p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.message) + " ", 1),
    (_ctx.allowRetry)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry'))),
          class: "try-again mt-4 cursor-pointer text-blue-900"
        }, " Try again? "))
      : _createCommentVNode("", true)
  ]))
}